import React from 'react'
import "./orderlist.css"

function Orderlist() {
  return (
    <div className='orderlist'>
        
        <div className="orderlist_container">
            <h1>Orderlist</h1>
            </div> 
        </div>
  )
}

export default Orderlist